import { DomainScopes } from "../../constants/DomainConstants";
import * as types from "../../constants/ComponentConstants";

export function GetTopNavItemsForScope(topNavTabSettings, scope) {
    let items;
    switch (scope) {
        case DomainScopes.DOSSIERINFRASTRUCTUUR:
            items = getTopNavItemsForDossierInfrastructuur(topNavTabSettings);
            break;
        case DomainScopes.VOORTGANGSRAPPORT:
            items = getTopNavItemsForVoortgangsrapport(topNavTabSettings);
            break;
        default:
            items = getTopNavItemsForDossierInfrastructuur(topNavTabSettings);
            break;
    }

    return items;
}

function getTopNavItemsForDossierInfrastructuur(topNavTabSettings) {
    return [{
        text: "Aanvrager",
        to: "/aanvraag" + topNavTabSettings.dossierTab.urlSuffix,
        iconType: types.ICON_AANVRAAG,
        color: types.COLOR_BLUE,
        disabled: topNavTabSettings.dossierTab.disabled,
        visible: topNavTabSettings.dossierTab.visible
    }, {
        text: "Project",
        to: "/project" + topNavTabSettings.projectTab.urlSuffix,
        iconType: types.ICON_PROJECT,
        color: types.COLOR_PINK,
        disabled: topNavTabSettings.projectTab.disabled,
        visible: topNavTabSettings.projectTab.visible
    }, {
        text: "Minimale eisen",
        to: "/minimaleeisen" + topNavTabSettings.minimaleEisenTab.urlSuffix,
        iconType: types.ICON_MINIMALEEISEN,
        color: types.COLOR_GREEN_LIGHT,
        disabled: topNavTabSettings.minimaleEisenTab.disabled,
        visible: topNavTabSettings.minimaleEisenTab.visible
    }, {
        text: "Financieel",
        to: "/financieel" + topNavTabSettings.financieelTab.urlSuffix,
        iconType: types.ICON_FINANCIEEL,
        color: types.COLOR_PINK_LIGHT,
        disabled: topNavTabSettings.financieelTab.disabled,
        visible: topNavTabSettings.financieelTab.visible
    }, {
        text: "Bovenlokaliteit",
        to: "/bovenlokaliteit" + topNavTabSettings.bovenLokaliteitTab.urlSuffix,
        iconType: types.ICON_BOVENLOKALITEIT,
        color: types.COLOR_PURPLE,
        disabled: topNavTabSettings.bovenLokaliteitTab.disabled,
        visible: topNavTabSettings.bovenLokaliteitTab.visible
    }, {
        text: "Beoordelingscriteria",
        to: topNavTabSettings.beoordelingscriteriaTab.url + topNavTabSettings.beoordelingscriteriaTab.urlSuffix,
        iconType: types.ICON_BEOORDELINGSCRITERIA,
        color: types.COLOR_ORANGE,
        disabled: topNavTabSettings.beoordelingscriteriaTab.disabled,
        visible: topNavTabSettings.beoordelingscriteriaTab.visible
    }, {
        text: "Dien in",
        to: "/indienen" + topNavTabSettings.indienenTab.urlSuffix,
        iconType: types.ICON_INDIENEN,
        color: types.COLOR_GREEN,
        disabled: topNavTabSettings.indienenTab.disabled,
        visible: topNavTabSettings.indienenTab.visible
    }];
}

function getTopNavItemsForVoortgangsrapport(topNavTabSettings) {
    return [{
        text: "Project",
        to: "/voortgangsrapport/project" + topNavTabSettings.projectTab.urlSuffix,
        iconType: types.ICON_PROJECT,
        color: types.COLOR_PINK,
        disabled: topNavTabSettings.projectTab.disabled,
        visible: topNavTabSettings.projectTab.visible
    }, {
        text: "Beoordelingscriteria",
        to: "/voortgangsrapport/beoordelingscriteria" + topNavTabSettings.beoordelingscriteriaTab.urlSuffix,
        iconType: types.ICON_BEOORDELINGSCRITERIA,
        color: types.COLOR_ORANGE,
        disabled: topNavTabSettings.beoordelingscriteriaTab.disabled,
        visible: topNavTabSettings.beoordelingscriteriaTab.visible
    }, {
        text: "Verantwoording",
        to: "/voortgangsrapport/verantwoording" + topNavTabSettings.verantwoordingTab.urlSuffix,
        iconType: types.ICON_FINANCIELEVERANTWOORDING,
        color: types.COLOR_PINK_LIGHT,
        disabled: topNavTabSettings.verantwoordingTab.disabled,
        visible: topNavTabSettings.verantwoordingTab.visible
    }, {
        text: "Dien in",
        to: "/voortgangsrapport/indienen" + topNavTabSettings.indienenTab.urlSuffix,
        iconType: types.ICON_INDIENEN,
        color: types.COLOR_GREEN,
        disabled: topNavTabSettings.indienenTab.disabled,
        visible: topNavTabSettings.indienenTab.visible
    }];
}